import {
  columnFacetingFeature,
  columnResizingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createFacetedUniqueValues,
  createSortedRowModel,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from '@tanstack/react-table';

export const appTableFeatures = tableFeatures({
  columnFacetingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  columnResizingFeature,
  rowSelectionFeature,
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  facetedUniqueValues: createFacetedUniqueValues(),
  columnMeta: {} as { align?: 'left' | 'right' | 'center' },
});

export type AppTableFeatures = typeof appTableFeatures;
